export const testIds = {
  AssetContainer: 'assetContainer-',
  AssetsRow: 'assets-row-',
  CreditCardLiabilitiesRow: 'creditcard',
  MortgageLiabilitiesRow: 'mortgage',
  CSAssetsRow: 'checkingsavings',
  InvestmentAssetsRow: 'investment',
  PropertyAssetsRow: 'property',
  Dashboard: {
    normalizedGross: 'normalized-gross',
    grossWhileWorking: 'normalized-gross-while-working',
    normalizedGrossInRetirement: 'normalizedGrossInRetirement',
  },
}
